const petSpecies = [
    { value: 'dog', label: { en: 'Dog', es: 'Perro' } },
    { value: 'cat', label: { en: 'Cat', es: 'Gato' } },
    { value: 'rabbit', label: { en: 'Rabbit', es: 'Conejo' } },
];

export default petSpecies;